import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "noFunctionsFound" }
const _hoisted_2 = { class: "table-header p-d-flex" }
const _hoisted_3 = { class: "p-input-icon-left p-mr-3 p-col-12" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_component_DataTable, {
    id: "environment-datatable",
    value: _ctx.environmentLibraries,
    paginator: true,
    rows: _ctx.functionsCatalogDatasetEnvironmentTableDescriptor.rows,
    class: "p-datatable-sm kn-table",
    dataKey: "name",
    filters: _ctx.filters,
    "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters = $event)),
    globalFilterFields: _ctx.functionsCatalogDatasetEnvironmentTableDescriptor.globalFilterFields,
    responsiveLayout: _ctx.functionsCatalogDatasetEnvironmentTableDescriptor.responsiveLayout,
    breakpoint: _ctx.functionsCatalogDatasetEnvironmentTableDescriptor.breakpoint,
    onRowClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('selected', $event.data)))
  }, {
    empty: _withCtx(() => [
      _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
    ]),
    header: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_InputText, {
            class: "kn-material-input",
            modelValue: _ctx.filters['global'].value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
            type: "text",
            placeholder: _ctx.$t('common.search'),
            "data-test": "filterInput"
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.functionsCatalogDatasetEnvironmentTableDescriptor.columns, (col) => {
        return (_openBlock(), _createBlock(_component_Column, {
          class: "kn-truncated",
          style: col.style,
          field: col.field,
          header: _ctx.$t(col.header),
          key: col.field,
          sortable: true
        }, null, 8, ["style", "field", "header"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value", "rows", "filters", "globalFilterFields", "responsiveLayout", "breakpoint"]))
}